export const CircleDiagramOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
        display: false
    }
}
